import { createGlobalStore } from 'hox';
import { useState } from 'react';
import config from 'src/config';
import timeZone from 'src/mapping/timeZone.json';

import { TimeZone } from '../components/CasHeader/TimeZone/ConsoleSetting';
const timeZoneItems = timeZone.timeZone;
const defaultOffset =
  localStorage.getItem('casUtcOffset') || config.ui.timeZone.defaultOffset;
const defaultOffsetId =
  localStorage.getItem('casUtcOffsetId') || config.ui.timeZone.defaultOffsetId;

function useUtcOffset() {
  const [offset, setOffset] = useState(defaultOffset);
  const [offsetId, setOffsetId] = useState(defaultOffsetId);
  const setUtcOffset = (utcOffset: string) => {
    setOffset(utcOffset);
    localStorage.setItem('casUtcOffset', utcOffset);
    const timeZoneItem = (timeZoneItems as any).find(
      (x: TimeZone) => x.key === utcOffset
    );
    if (timeZoneItem) {
      setOffsetId(timeZoneItem.id);
      localStorage.setItem('casUtcOffsetId', timeZoneItem.id);
    }
  };

  const setUtcOffsetId = (offsetId: string) => {
    setOffsetId(offsetId);
    localStorage.setItem('casUtcOffsetId', offsetId);
    const timeZoneItem = (timeZoneItems as any).find(
      (x: TimeZone) => x.id === offsetId
    );
    if (timeZoneItem) {
      setOffset(timeZoneItem.key);
      localStorage.setItem('casUtcOffset', timeZoneItem.key);
    }
  };

  return {
    offset,
    offsetId,
    setUtcOffsetId,
    setUtcOffset,
  };
}
export const [useUtcOffsetStore, getUtcOffsetStore] =
  createGlobalStore(useUtcOffset);
